module.exports = __webpack_public_path__ + "3f16e137/img/revit-icon.5ff0d581.svg";